import React from "react";

const RestorePassEmailSendSuccess: React.FC = () => {
  return (
    <p>На указанный вами адрес выслано письмо с ссылкой. Откройте почту и пойдите по ссылке для сброса пароля. Если письмо не пришло, проверьте папку «Спам» или попробуйте еще раз.</p>
  )
};

export default RestorePassEmailSendSuccess;